<template>
  <v-layout column>
    <v-flex>
      <v-card>
        <v-toolbar class="elevation-0" height="45" color="gray">
          <v-toolbar-title>
            <h1 class="subheading">{{ $t("labels.status") }}</h1>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout column>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.requestInfoUpdate") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button @change="updateReqUpdatedInfo" v-model="reqUpdatedInfo" :labels="true"
                  :value="reqUpdatedInfo" :sync="true"></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.hideCommerical") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button @change="updateHideCommercial" v-model="hideCommercial" :labels="true"
                  :value="hideCommercial" :sync="true"></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.testLocation") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button @change="updateTestStore" v-model="testStore" :labels="true" :value="testStore"
                  :sync="true"></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.softwareInstalled") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button @change="updateInstallation" v-model="installationDone"
                  :labels="{ checked: 'Yes', unchecked: 'No' }" :color="{
                    checked: '#21BED5',
                    unchecked: '#B7C4D3',
                    disabled: '#CCCCCC',
                  }" :value="installationDone" :sync="true"></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>Twilio Text Alert</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button @change="updateTwilioAlert" v-model="twilioAlert"
                  :labels="{ checked: 'Yes', unchecked: 'No' }" :color="{
                    checked: '#21BED5',
                    unchecked: '#B7C4D3',
                    disabled: '#CCCCCC',
                  }" :value="twilioAlert" :sync="true"></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>Surcharge</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button @change="updateSurcharge" v-model="surcharge"
                  :labels="{ checked: 'on', unchecked: 'off' }" :color="{
                    checked: '#21BED5',
                    unchecked: '#B7C4D3',
                    disabled: '#CCCCCC',
                  }" :value="surcharge" :sync="true"></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap align-center>
              <v-flex>Dual Pricing</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <!-- <v-btn color="blue darken-1" class="mr-0" dark small round>Open</v-btn> -->
                <DualPricing class="mr-0" />
                <!-- <toggle-button @change="updateCashDiscount()" v-model="dualPrice"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }" :color="{
                    checked: '#21BED5',
                    unchecked: '#B7C4D3',
                    disabled: '#CCCCCC',
                  }" :value="twilioAlert" :sync="true"></toggle-button> -->
              </v-flex>
            </v-layout>
            <!-- <div v-if="dualPrice">
              <v-divider></v-divider>
              <v-layout row wrap>
                <v-flex>Dual Pricing Rate</v-flex>
                <v-spacer></v-spacer>
                <v-flex class="text-xs-right">
                  <v-text-field v-model="dualPriceRate" outline dense hide-details></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-btn color="blue darken-1" dark block @click="updateCashDiscount()">Update</v-btn>
                </v-flex>
              </v-layout>
            </div> -->
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import locationService from '../service.js';
import DualPricing from './DualPricing.vue';

export default {
  data() {
    return {
      testStore: false,
      reqUpdateInfo: false,
      hideCommercial: false,
      installationDone: false,
      twilioAlert: false,
      surcharge: false,
    };
  },
  components: { DualPricing },
  created() {
    this.setStatus();
    // console.log('location', location)
  },
  watch: {
    location() {
      this.setStatus();
    },
  },
  computed: {
    ...mapGetters('location', ['location', 'organization']),
    ...mapGetters('global', ['currentUser', 'checkRightStatus']),
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    setStatus() {
      console.log('getting location', this.location)
      this.testStore = this.location.testStore;
      this.reqUpdatedInfo = this.location.reqUpdatedInfo;
      this.hideCommercial = this.location.hideCommercial;
      this.installationDone = this.location.installationDone;
      this.twilioAlert = this.location.twilioAlert;
      this.surcharge = this.location.surcharge;
    },
    updateStore(data) {
      return locationService
        .updateStore(this.location.storeID, data)
        .then((result) => {
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: 'success',
              title: 'Update Successfully',
            });
          this.setLocation(this.location.storeID);
        });
    },
    updateInstallation(val) {
      const data = { installationDone: this.installationDone };
      // console.log('installation', data);
      this.updateStore(data);
    },
    updateTwilioAlert(val) {
      const data = { twilioAlert: this.twilioAlert };
      // console.log('updateTwilioAlert', data);
      this.updateStore(data);
    },
    updateSurcharge() {
      const data = { surcharge: this.surcharge };
      // console.log('updateTwilioAlert', data);
      this.updateStore(data);
    },
    // updateCashDiscount() {
    //   const data = { dualPrice: this.dualPrice, dualPriceRate: this.dualPriceRate };
    //   // console.log('updateTwilioAlert', data);
    //   this.updateStore(data);
    // },

    async updateTestStore(val) {
      const { value: text } = await this.$swal.fire({
        title: 'Reason',
        input: 'textarea',
        inputPlaceholder: 'Type your message here...',
        showCancelButton: true,
      });
      if (text) {
        const data = {
          lockReason: text,
          testStore: val.value,
        };
        console.log('update locak', data);
        this.updateStore(data);
      } else {
        this.testStore = !this.testStore;
      }
    },
    async updateReqUpdatedInfo(val) {
      const { value: text } = await this.$swal.fire({
        title: 'Reason',
        input: 'textarea',
        inputPlaceholder: 'Type your message here...',
        showCancelButton: true,
      });
      if (text) {
        const data = {
          lockReason: text,
          reqUpdatedInfo: val.value,
        };
        console.log('update locak', data);
        this.updateStore(data);
      } else {
        this.reqUpdatedInfo = !this.reqUpdatedInfo;
      }
    },
    async updateHideCommercial(val) {
      const { value: text } = await this.$swal.fire({
        title: 'Reason',
        input: 'textarea',
        inputPlaceholder: 'Type your message here...',
        showCancelButton: true,
      });
      if (text) {
        const data = {
          lockReason: text,
          hideCommercial: val.value,
        };
        console.log('update locak', data);
        this.updateStore(data);
      } else {
        this.hideCommercial = !this.hideCommercial;
      }
    },
  },
};
</script>

<style scoped></style>
